<template>
    <div class="container">
        <h2>{{ title }}</h2>
        <div>
            <button @click="selectType('Ongelma')">Ongelma</button>
            <button @click="selectType('Haaste')">Haaste</button>
            <button @click="selectType('Toive')">Toive</button>
        </div>
    </div>
</template>

<script>

import {reactive} from "vue";
import Card from "./Card.vue";
import Answer from "./Answer.vue";

export default {
    name: "CardTypeSelection",
    props: {
        theme: String,
        title: String,
    },
    components: {
        Card,
        Answer
    },
    setup(props, { emit }) {
        const state = reactive({cardsToChooseFrom: []});

        const selectType = (type) => {
            const cardArray = JSON.parse(localStorage.getItem("cardArray"));

            state.cardsToChooseFrom = cardArray.filter(card => {
                if (card.phase1selection == type && !card.phase2selection)
                    return card;
            });

            emit('saveCardsToChooseFrom', state.cardsToChooseFrom, type);
        }

        return { state, selectType };
    },
    emits: ['saveCardsToChooseFrom'],
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body, #answerBox {
    margin: 0px;
    padding: 0px;
}

h2 {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: var(--link_color);
}

p {
    color: #111;
}

@media only screen and (max-width: 500px) {
    button {
        margin: 5px 5px;
    }
}

</style>
